import {MODULE_DISTRIBUTION_APP} from '../../../../constants/main.module.constants';
export const MODULE_BASE_CONFIG = MODULE_DISTRIBUTION_APP + '.base.config';

function baseConfig($stateProvider) {
	let $delegate = $stateProvider.state;
	$stateProvider.state = (name, definition) => {
		definition = definition || name;
		if (!definition.resolve) {
			definition.resolve = {};
		}

		return $delegate.apply($stateProvider, [name, definition]);
	};
}

baseConfig.$inject = ['$stateProvider'];

angular.module(MODULE_BASE_CONFIG, ['ui.router'])
       .config(baseConfig);




// WEBPACK FOOTER //
// ./modules/distribution/core/utils/base.config.js